import * as uuid from 'uuid'
import { Objects } from '../object-definitions'
import { Chili as _Chili } from './chili'
import { ImageAsset as _ImageAsset } from './image-asset'
import { MailingOrder as _MailingOrder } from './mailing-order'
import { Mls as _Mls } from './mls'
import { arrayToMap as _arrayToMap, mapToArray as _mapToArray } from './others'
import { Product as _Product } from './product'
import { SimpleEditorConfiguration as _SimpleEditorConfiguration } from './simple-editor-configuration'
import { Subscription as _Subscription } from './subscription'
import { User as _User } from './user'
import { UXConfigEstablishment as _UXConfigEstablishment } from './ux-config-establishment'

export namespace Utils {
    export import Chili = _Chili
    export import ImageAsset = _ImageAsset
    export import MailingOrder = _MailingOrder
    export import Mls = _Mls
    export import Product = _Product
    export import SimpleEditorConfiguration = _SimpleEditorConfiguration
    export import Subscription = _Subscription
    export import User = _User
    export import UXConfigEstablishment = _UXConfigEstablishment

    // TODO Misleading, also checks if undefined
    export function isAnyNullOrUndefined(...params: unknown[]) {
        return params.some((x) => x === null || x === undefined)
    }

    // TODO Misleading, also throws if undefined
    export function throwIfNullOrUndefined<T>(obj: T): NonNullable<T> | never {
        if (Utils.isNotNullNorUndefined(obj)) {
            return obj
        }

        throw new Error('Non-null assertion failed')
    }

    export function throwError(err: Error): never {
        throw err
    }

    // TODO Misleading, also checks if undefined
    // TODO Refactor isNot in name adds complexity
    export function isNotNullNorUndefined<T>(obj: T): obj is NonNullable<T> {
        return obj !== null && obj !== undefined
    }

    export function hasEmptyProperties(obj: object) {
        const response = Object.getOwnPropertyNames(obj).length === 0
        return response
    }

    export function hasAnyProperty(obj: object) {
        return !!Object.getOwnPropertyNames(obj).length
    }

    export const arrayToMap = _arrayToMap

    export const mapToArray = _mapToArray

    export function getKeyValuePairs<T>(map: Record<string, T | undefined>) {
        const arr: { key: string; value: T }[] = []
        for (const key of Object.getOwnPropertyNames(map)) {
            const value = map[key]
            if (!value) {
                continue
            }
            arr.push({
                key,
                value,
            })
        }
        return arr
    }

    export function deepCloneObject<T>(obj: T): T {
        return JSON.parse(JSON.stringify(obj))
    }

    // export function isColorStringValid(rgbOrCmykString: string): boolean {
    //     if(!rgbOrCmykString.endsWith(')')){
    //         return false
    //     }
    //     if(rgbOrCmykString.startsWith('rgb(')){
    //         const arr = rgbOrCmykString.substring(4, rgbOrCmykString.length - 1).split(',')
    //         if(arr.length !== 3){

    //         }
    //     }else if(rgbOrCmykString.startsWith('cmyk(')){

    //     }else{
    //         return false
    //     }
    // }
    export function isColorObjectValid(rgbOrCmykObj: Objects.Color.Any): boolean {
        let props: number[]
        if ('r' in rgbOrCmykObj) {
            props = [rgbOrCmykObj.r, rgbOrCmykObj.g, rgbOrCmykObj.b, rgbOrCmykObj.a]

            return !props.some((x) => x === undefined || x === null || x < 0 || x > 255)
        } else {
            props = [rgbOrCmykObj.c, rgbOrCmykObj.m, rgbOrCmykObj.y, rgbOrCmykObj.k, rgbOrCmykObj.a]

            return !props.some((x) => x === undefined || x === null || x < 0 || x > 1)
        }
    }

    export function doArraysIntersect(arr1: string[], arr2: string[]) {
        return arr1.some((item1) => arr2.includes(item1))
    }

    export function tryGet<T, K extends keyof T>(obj: T | undefined, key: K): T[K] | undefined {
        if (obj === null || obj === undefined) {
            return undefined
        }

        return obj[key]
    }

    export function generateId() {
        return uuid.v4()
    }

    export function getMailingOrderBasePath(mailingOrderId: string | undefined, params?: { withLeadingSlash?: boolean }) {
        const { withLeadingSlash } = params ?? {}
        const base = `${withLeadingSlash ? '/' : ''}admin/mailing/drafts`
        if (!mailingOrderId) {
            return base
        }
        return `${base}/v2/${mailingOrderId}`
    }

    // TODO Move into Client code
    export function parseIdFromImgXML(imgXML: string) {
        const regex = /id="(.+?)"/
        return regex.exec(imgXML)?.[1] || ''
    }

    // TODO Move into Client code
    export function parsePropertyFromImgXML(imgXML: string, propertyName: string) {
        const regex = new RegExp(`${propertyName}="(.+?)"`)
        return regex.exec(imgXML)?.[1] || ''
    }

    export function getFormattedPrice(priceCents: number, allowCentsFormat: boolean) {
        return priceCents < 100 && allowCentsFormat ? `${priceCents}¢` : `$${(priceCents / 100).toFixed(2)}`
    }

    export function getObjectKeys<T extends object>(o: T): Array<keyof T> {
        // eslint-disable-next-line no-type-assertion/no-type-assertion
        return <Array<keyof T>>Object.keys(o)
    }
}
